export default {
  title: 'Disponibilidad de los Lugares',
  list: 'Lista',
  kanban: 'Kanban',

  place: 'Lugar',
  status: 'Estado',
  'status.available': 'Disponible',
  'status.unavailable': 'No disponible',

  origin: 'Origen del último cambio',
  'origin.non_compliance': 'No conformidad',
  'origin.automation': 'Automatización',
  'origin.manual': 'Manual',

  changedAt: 'Fecha del último cambio',
  responsible: 'Responsable',
  openNonCompliances: 'No conformidades abiertas',
  noResponsible: 'Automático',
  neverChanged: 'Nunca alterado',

  changeStatusManually: 'Alterar estado manualmente',
  changeStatusTo: 'Alterar el estado del lugar a',
  reason: 'Motivo (opcional)',
  reasonPlaceholder: 'Describe el motivo del cambio',
  confirmChangeStatus: '¿Estás seguro de que deseas alterar el estado de disponibilidad de este lugar?',
  changeStatusSuccess: 'Estado de disponibilidad alterado con éxito.',
  changeStatusError: 'Ocurrió un error al alterar el estado de disponibilidad.',

  filterByStatus: 'Estado de disponibilidad',
  filterByOrigin: 'Origen del último cambio',

  moreOptions: 'Más opciones',
  automations: 'Automatizaciones',

  'statusSourceConfig.buttonLabel': 'Configuraciones',
  'statusSourceConfig.title': 'Origen del Estado de Disponibilidad',
  'statusSourceConfig.description':
    'Seleccione de dónde puede actualizarse automáticamente el estado de disponibilidad de los lugares.',
  'statusSourceConfig.nonCompliance': 'No Conformidad',
  'statusSourceConfig.automation': 'Automatización',

  'tabs.details': 'Detalles',
  'tabs.history': 'Historial',

  'history.empty': 'Todavía no hay historial de cambios de estado para este lugar.',
  'history.lastChange': 'Último cambio de estado',
  'history.changedTo': 'Estado alterado a {{status}}',

  'openNonCompliancesList.title': 'No conformidades abiertas',
  'openNonCompliancesList.empty': 'Este lugar no tiene no conformidades abiertas.',

  'modals.changeAvailabilityStatus': 'Alterar estado de disponibilidad',
  'modals.availabilityDetails': 'Disponibilidad del lugar'
}
